import { Bar } from "vue-chartjs";

export default {
  extends: Bar,

  props: {
    label: {
      type: Array,
      required: true
    },
    data_graph: {
      type: Array,
      required: true
    }
  },
  mounted() {
    this.renderChart(
      {
        labels: this.label,
        datasets: [
          {
            label: "Stockout",
            backgroundColor: "#f87979",
            data: this.data_graph
          }
          // {
          //   label: "Delivery Order",
          //   backgroundColor: "#7C8CF8",
          //   data: this.data_graph
          // }
        ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  }
};
